import React from 'react';
import { ReactComponent as FigMail01Component } from './FigMail01.svg';

const FigMail01 = (props) => <FigMail01Component {...props} />;

export default FigMail01;
